type Props = {
    customerService:any
}

export default function CustomerServiceSummaryItem ({customerService}:Props){

    return(
        <li>
        <div>
          {customerService.name}
        </div>
        <section>
          <ul>
            {customerService.services.filter((s:any) => s.enabled).map((service:any) => {
              return <CustomerServiceSummaryItem key={service.id} customerService={service} />;
            })}
          </ul>
        </section>
      </li>
    )
}